export class AwsFsxResource {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "fileSystemId",
            "baseName": "fileSystemId",
            "type": "string",
            "format": ""
        },
        {
            "name": "fileSystemType",
            "baseName": "fileSystemType",
            "type": "AwsFsxResourceFileSystemTypeEnum",
            "format": ""
        },
        {
            "name": "deploymentType",
            "baseName": "deploymentType",
            "type": "string",
            "format": ""
        },
        {
            "name": "storageSize",
            "baseName": "storageSize",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "storageType",
            "baseName": "storageType",
            "type": "AwsFsxResourceStorageTypeEnum",
            "format": ""
        },
        {
            "name": "lifecycleStatus",
            "baseName": "lifecycleStatus",
            "type": "AwsFsxResourceLifecycleStatusEnum",
            "format": ""
        },
        {
            "name": "vpcId",
            "baseName": "vpcId",
            "type": "string",
            "format": ""
        },
        {
            "name": "subnetIds",
            "baseName": "subnetIds",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "dnsName",
            "baseName": "dnsName",
            "type": "string",
            "format": ""
        },
        {
            "name": "kmsKeyId",
            "baseName": "kmsKeyId",
            "type": "string",
            "format": ""
        },
        {
            "name": "name",
            "baseName": "name",
            "type": "string",
            "format": ""
        },
        {
            "name": "ownerId",
            "baseName": "ownerId",
            "type": "string",
            "format": ""
        },
        {
            "name": "ontapVolumes",
            "baseName": "ontapVolumes",
            "type": "Array<FsxOntapVolume>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return AwsFsxResource.attributeTypeMap;
    }
    constructor() {
    }
}
export var AwsFsxResourceFileSystemTypeEnum;
(function (AwsFsxResourceFileSystemTypeEnum) {
    AwsFsxResourceFileSystemTypeEnum["Windows"] = "WINDOWS";
    AwsFsxResourceFileSystemTypeEnum["Lustre"] = "LUSTRE";
    AwsFsxResourceFileSystemTypeEnum["Ontap"] = "ONTAP";
    AwsFsxResourceFileSystemTypeEnum["Openzfs"] = "OPENZFS";
})(AwsFsxResourceFileSystemTypeEnum || (AwsFsxResourceFileSystemTypeEnum = {}));
export var AwsFsxResourceStorageTypeEnum;
(function (AwsFsxResourceStorageTypeEnum) {
    AwsFsxResourceStorageTypeEnum["Ssd"] = "SSD";
    AwsFsxResourceStorageTypeEnum["Hdd"] = "HDD";
    AwsFsxResourceStorageTypeEnum["IntelligentTiering"] = "INTELLIGENT_TIERING";
})(AwsFsxResourceStorageTypeEnum || (AwsFsxResourceStorageTypeEnum = {}));
export var AwsFsxResourceLifecycleStatusEnum;
(function (AwsFsxResourceLifecycleStatusEnum) {
    AwsFsxResourceLifecycleStatusEnum["Available"] = "AVAILABLE";
    AwsFsxResourceLifecycleStatusEnum["Creating"] = "CREATING";
    AwsFsxResourceLifecycleStatusEnum["Failed"] = "FAILED";
    AwsFsxResourceLifecycleStatusEnum["Deleting"] = "DELETING";
    AwsFsxResourceLifecycleStatusEnum["Misconfigured"] = "MISCONFIGURED";
    AwsFsxResourceLifecycleStatusEnum["Updating"] = "UPDATING";
    AwsFsxResourceLifecycleStatusEnum["MisconfiguredUnavailable"] = "MISCONFIGURED_UNAVAILABLE";
})(AwsFsxResourceLifecycleStatusEnum || (AwsFsxResourceLifecycleStatusEnum = {}));
